import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css';
import './index.css';

// Ensure DOM is ready before mounting
function mount() {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    // Fail gracefully instead of throwing, to avoid breaking fallback previews
    console.error('Failed to find root element (#root). React app will not be mounted.');
    return;
  }

  const root = ReactDOM.createRoot(rootElement);
  root.render(<App />);
}

// Mount immediately if DOM is ready, otherwise wait for DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount);
} else {
  mount();
}
